/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
    Card,
    Grid,
    TextField
} from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import WarningModal from "components/displayModel/warningModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getWeightChargesById, saveWeightCharges, updateWeightCharges } from "utils/api";
import { blank, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
    color: `red`,
    fontSize: `11px`,
};


let fetchedCragoWeight;

let LOGIN_DETAILS;

function AddCargoWeightCharges() {
    const { id } = useParams();
    const { shipmentChargeID } = useParams();

    const [screenName, setScreenName] = useState("Add Cargo Weight Charges");
    const [loading, setLoading] = useState(false);
    const [cwcZoneNameErr, setCwcZoneNameErr] = useState(false);
    const [cwcFromDistanceErr, setCwcFromDistanceErr] = useState(false);
    const [cwcToDistanceErr, setCwcToDistanceErr] = useState(false);
    const [cwcCargoWeightChargesErr, setCwcCargoWeightChargesErr] = useState(false);
    const [confirmDialogeFlag, setConfirmDialogeFlag] = useState(false);
    const [disableColor, setDisableColor] = useState(false);
    const [errCargoWeightTime, setErrCargoWeightTime] = useState("");
    
    const [controller] = useMaterialUIController();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { sidenavColor, darkMode } = controller;


    let mandateFlag = false;

    const [cargoweight1, setCargoweight1] = useState({
        cwcZoneName: '',
        cwcToDistance: '',
        cwcFromDistance: '',
        cwcCargoWeightCharges: '',
        shipmentChargeID,
    });


    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    cargoweight1.businessUserID = LOGIN_DETAILS?.businessUserID;

    const handleChangeWeight = (name) => (event) => {
        if (event.target.validity.valid) {
            setCargoweight1({ ...cargoweight1, [name]: event.target.value });
        }
    };

    const fromDistance = parseInt(cargoweight1.cwcFromDistance);
    const toDistance = parseInt(cargoweight1.cwcToDistance);



    useEffect(() => {
        getRight()
        if (id !== undefined) {
            setScreenName("Edit Cargo Weight Charges")
            cargoweight1._id = id;
            getWeightChargesById(cargoweight1 , (data)=>{
                console.log("fsdfdsf , ", data)
                if (data.Result_Output.length > 0) {
                    let selectedIDData
                    for (let weightCharge of data.Result_Output) {
                        if (weightCharge._id === id) {
                            selectedIDData = weightCharge
                        }
                    }
                    fetchedCragoWeight = data.Result_Output;
                    setCargoweight1(selectedIDData)
                }

            },dispatch)
      
        }
      
    }, []);
    async function getRight() {
        let right = await getScreenRight("Shipment Charges")
        if (right === "Full Access") 
            setDisableColor(false)
        else setDisableColor(true)

    }

    const addCargoWeight = () => {
       let  cargoWeightErr = false
        sessionStorage.setItem("PARA_TABLE", "CargoWeightCharges");
        mandateFlag = validateField(cargoweight1.cwcZoneName, setCwcZoneNameErr) || mandateFlag;
        if (cargoweight1.cwcFromDistance.toString().trim() === "") {
            setCwcFromDistanceErr("From Distance can't be blank");
            mandateFlag = true;
        } else setCwcFromDistanceErr(false);
        if (cargoweight1.cwcToDistance.toString().trim() === "") {
            setCwcToDistanceErr("To Distance can't be blank");
            mandateFlag = true;
        }
        else if (cargoweight1.cwcFromDistance === cargoweight1.cwcToDistance) {
            setCwcToDistanceErr("To Distance can't be same as From Distance");
            mandateFlag = true;
        }
        else if (toDistance < fromDistance) {
            setCwcToDistanceErr("To Distance must be greater than From Distance");
            mandateFlag = true;
        } else setCwcToDistanceErr(false);
        if (cargoweight1.cwcCargoWeightCharges.toString().trim() === "") {
            setCwcCargoWeightChargesErr("Cargo Weight Charges can't be blank");
            mandateFlag = true;
        } else setCwcCargoWeightChargesErr(false);

        if (mandateFlag) {
            return;
        }

        if (id === undefined || id === '') {
            cargoweight1.shipmentChargeID = shipmentChargeID;
            saveWeightCharges(cargoweight1 , (data)=>{
                showResMsg(data.Result_Status ?  genericMessage.added :data.Result_Message, 1000, data.Result_Status, navigate, '/shipmentCharges');
            },dispatch)
           
        }
        else   {
            for (let i = 0; i < fetchedCragoWeight.length; i++) {
                if (fetchedCragoWeight[i]._id === id) {
                    
                  if (fetchedCragoWeight[i].cwcFromDistance !== 0) {
                     if  (fetchedCragoWeight[i - 1].cwcToDistance+1 !== parseInt(cargoweight1.cwcFromDistance)){
                        cargoWeightErr = true
                      setErrCargoWeightTime("From Distance")
                    }
                     if  (fetchedCragoWeight[i - 1].cwcToDistance > parseInt(cargoweight1.cwcFromDistance)) {
                        cargoWeightErr = true
                        setErrCargoWeightTime("From Distance") 
                    }
                    if(fetchedCragoWeight[i + 1] ){
                        if (fetchedCragoWeight[i + 1].cwcFromDistance < parseInt(cargoweight1.cwcToDistance)) {
                            setErrCargoWeightTime("To Distance")
                          cargoWeightErr = true
                        }else if( fetchedCragoWeight[i + 1].cwcFromDistance-1  !==  parseInt(cargoweight1.cwcToDistance)){

                            setErrCargoWeightTime("To Distance")
                            cargoWeightErr = true
                        }
                    }
                   
                  } else {
                    if(fetchedCragoWeight[i + 1]){
                        if (fetchedCragoWeight[i + 1].cwcFromDistance < parseInt(cargoweight1.cwcToDistance)) {
                            setErrCargoWeightTime("To Distance")
                          cargoWeightErr = true
                        }else if( fetchedCragoWeight[i + 1].cwcFromDistance-1  !==  parseInt(cargoweight1.cwcToDistance)){

                            setErrCargoWeightTime("To Distance")
                            cargoWeightErr = true
                        }
                    }
                  
                  }
                }
              }
            
            if(!cargoWeightErr){
                updatefetchWeightCharges()
              }else{
        
                setConfirmDialogeFlag(true)
              }

        }
    };


    const handleCancel = name => event => {
        setConfirmDialogeFlag(false);
    };

    const handleChangeValue = async (id) => {
        updatefetchWeightCharges();
        setConfirmDialogeFlag(!confirmDialogeFlag);
    };

    const updatefetchWeightCharges = async () => {
        updateWeightCharges(cargoweight1 , (data)=>{
            showResMsg(data.Result_Status ?  genericMessage.updated:data.Result_Message, 1000, data.Result_Status, navigate, '/shipmentCharges');

        },dispatch)
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={6} mb={3}>
                <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid item xs={10} spacing={6} >
                        <Card sx={{ boxShadow: "none" }}>
                            <MDBox
                                mx={2}
                                mt={-3}
                                mb={1.5}
                                py={2}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    {screenName}
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={4} pb={3} px={3}>
                                <Grid container columnSpacing={5}>
                                    <Grid item xs={12} lg={3}>
                                        <MDBox component="form" role="form">
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Zone Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    autoFocus={true}
                                                    inputProps={{
                                                        pattern: "^[a-zA-Z0-9 ]*$",
                                                        maxLength: 20
                                                    }}
                                                    onChange={handleChangeWeight("cwcZoneName")}
                                                    value={cargoweight1.cwcZoneName}
                                                />
                                                {cwcZoneNameErr ? <p style={errMsg}>Zone Name can't be blank</p> : ""}
                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <MDBox component="form" role="form">
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="From Distance (Km)"
                                                    variant="outlined"
                                                    fullWidth
                                                    inputProps={{
                                                        pattern: "^[0-9]+$",
                                                        maxLength: 5
                                                    }}
                                                    disabled={(parseInt(cargoweight1.cwcFromDistance) === 0 && typeof id != 'undefined') ? true : false}
                                                    onChange={handleChangeWeight("cwcFromDistance")}
                                                    value={cargoweight1.cwcFromDistance}
                                                />
                                                {cwcFromDistanceErr !== "" ? <p style={errMsg}>{cwcFromDistanceErr}</p> : ""}
                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <MDBox component="form" role="form">
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="To Distance (Km)"
                                                    variant="outlined"
                                                    fullWidth
                                                    inputProps={{
                                                        pattern: "^[0-9]+$",
                                                        maxLength: 5
                                                    }}
                                                    onChange={handleChangeWeight("cwcToDistance")}
                                                    value={cargoweight1.cwcToDistance}
                                                />
                                                {cwcToDistanceErr !== "" ? <p style={errMsg}>{cwcToDistanceErr}</p> : ""}
                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <MDBox component="form" role="form">
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Cargo Weight Charges($/Kg.)"
                                                    variant="outlined"
                                                    fullWidth
                                                    inputProps={{
                                                        pattern: "^[0-9.]+$",
                                                        maxLength: 5
                                                    }}
                                                    onChange={handleChangeWeight("cwcCargoWeightCharges")}
                                                    value={cargoweight1.cwcCargoWeightCharges}
                                                />
                                                {cwcCargoWeightChargesErr !== "" ? <p style={errMsg}>{cwcCargoWeightChargesErr}</p> : ""}

                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
                <Grid
                    container
                    mt={2}
                    columnSpacing={4}
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>

                        <Link to={"/shipmentCharges"}>
                            <MDButton
                                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                color="warning"
                                fullWidth
                                onClick={() => { sessionStorage.setItem("PARA_TABLE", "CargoWeightCharges"); }}
                            >
                                Cancel
                            </MDButton>
                        </Link>
                    </Grid>
                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                        <MDButton
                            onClick={disableColor ? blank : addCargoWeight}
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            color={disableColor ? "secondary" : "success"}
                            fullWidth
                        >
                            {id !== undefined ? <>Update</>:<>Save</>}
                        </MDButton>
                    </Grid>

                </Grid>
            </MDBox>
            <WarningModal
                open={confirmDialogeFlag}
                errorMesssage={errCargoWeightTime}
                handleDelete={handleChangeValue}
                handleCancel={handleCancel("handleCancel")}
                closeModalClick={handleCancel("closeModalClick")}
            />
            <LoadingModal loading={loading} />
        </DashboardLayout>
    );
}

export default AddCargoWeightCharges;
